// extracted by mini-css-extract-plugin
module.exports = {"partners":"partners_partners__6ITGv","container":"partners_container__HWSuU","title":"partners_title__vYbVf"};